import { createFileRoute } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { siteWorkQuery } from '@/queries/site-work.query'
import { siteQuery } from '@/queries/site.query'

export const Route = createFileRoute('/_dashboard/site/$id/information/work/$workId/')({
  async loader({ params, context: { queryClient } }) {
    await queryClient.ensureQueryData(siteQuery(params.id))
    await queryClient.ensureQueryData(siteWorkQuery(params.id, params.workId, { enabled: !!params.workId }))
  },
  pendingComponent: PendingComponent,
})
